module.exports = __webpack_public_path__ + "static/media/connor.c8c6832e.png";